import { EInvoiceConsentLogEntryVM } from "./eInvoiceConsentLogEntryVM";
import { DateTime } from "luxon";

export function HistoryPresenterItem(props: { entry: EInvoiceConsentLogEntryVM }) {
  const { entry } = props;
  return (
    <tr>
      <td>{DateTime.fromISO(entry.dateCreated).toFormat("yyyy-MM-dd HH:mm")}</td>
      <td>{entry.userLogin}</td>
      <td className="text-center">{entry.consent ? "Tak" : "Nie"}</td>
      <td>{entry.eMail1}</td>
      <td>{entry.eMail2 ?? <small>Nie podano</small>}</td>
    </tr>
  );
}

export default HistoryPresenterItem;
